'use strict';

module.exports = /*@ngInject*/ ["$scope", "$uibModalInstance", "series", function ($scope, $uibModalInstance, series) {
    init();

    function init() {
        "use strict";
        $scope.series = series;
        $scope.allSeries = {
            checked: false
        };
        $scope.graphFilter = "";
    }

    $scope.allSeriesChanged = function(value) {
        "use strict";
        if(!value) {
            $scope.series.forEach(function (serie) {
                serie.checked = false;
            });
        }
    };

    $scope.serieChanged = function() {
        $scope.allSeries = {
            checked: $scope.series.reduce((acc, serie) => acc && serie.checked, true)
        };
    }

    $scope.serieFilter = function (item) {
        var returnValue = false;

        if (item.name.toLowerCase().indexOf($scope.graphFilter.toLowerCase()) !== -1 || $scope.graphFilter === "") {
            returnValue = true;
        }

        if ($scope.allSeries.checked) {
            item.checked = returnValue;
        }

        return returnValue;

    };

    $scope.close = function () {
        $uibModalInstance.dismiss();
    };

    $scope.clear = function () {
        $scope.series.forEach(function (serie) {
            serie.checked = false;
        });
        $uibModalInstance.close($scope.series);
    };

    $scope.save = function () {
        $uibModalInstance.close($scope.series);
    };
}];